export const UPDATE_ROUTER_PATH = 'router/UPDATE_ROUTER_PATH';

export const SET_ROUTE_LOADING = 'router/SET_ROUTE_LOADING';
export const SET_ROUTE_LOADING_COMPLETE = 'router/SET_ROUTE_LOADING_COMPLETE';

export const SET_SHOW_ROUTE_LOADER = 'router/SET_SHOW_ROUTE_LOADER';